import { makeImage } from "../utils";
import harvestForecast from "./harvest-forecast.svg";

export const HarvestForecast = makeImage({
  src: harvestForecast,
  width: 160,
  height: 160,
  dataTestId: "harvest-forecast",
});
